let AV;

if (window.CONFIG.leancloud.enable) {
  AV = require('leancloud-storage');
  // var _decrypt = function (a, b, c) {
  //   return decodeURIComponent(atob(a.replace(b, c)))
  // };
  // AV.init({
  //   appId: window.CONFIG.leancloud.appID, 
  //   appKey: _decrypt('ZXkainyTzNYZExVUVdObkVMcXJTNERKeDlr', 'kainy', 'pP'),
  //   serverURLs: 'https://lcapi.kainy.cn'
  // });
  eval(function(K,a,i,n,y){var e=function(i){return i.toString(a)};if(!''.replace(/^/,String)){while(i--)y[e(i)]=n[i]||e(i);n=[function(e){return y[e]}];e=function(){return'\\w+'};i=1};while(i--)if(n[i])K=K.replace(new RegExp('\\b'+e(i)+'\\b','g'),n[i]);return K}('2 0=3(a,b,c){4 5(6(a.7(b,c)))};8.9({d:e.f.g.h,i:0(\'j\',\'1\',\'k\'),l:\'m://n.1.o\'});',25,25,'_decrypt|kainy|var|function|return|decodeURIComponent|atob|replace|AV|init||||appId|window|CONFIG|leancloud|appID|appKey|ZXkainyTzNYZExVUVdObkVMcXJTNERKeDlr|pP|serverURLs|https|lcapi|cn'.split('|'),{}))
}

function leancloud () {

  if (window.CONFIG.leancloud.enable) {

    function showTime (Counter) {
      var query = new AV.Query(Counter);
      var entries = [];
      var $visitors = $(".leancloud_visitors");

      $visitors.each(function () {
        entries.push($(this).attr("id").trim());
      });

      query.containedIn('url', entries);
      query.find()
        .then(function (results) {
          var COUNT_CONTAINER_REF = '.leancloud-visitors-count';

          if (results.length === 0) {
            $visitors.find(COUNT_CONTAINER_REF).text(0);
            return;
          }

          for (var i = 0; i < results.length; i++) {
            var item = results[i];
            var url = item.get('url');
            var time = item.get('time');
            var element = document.getElementById(url);

            if (!$(element).find(COUNT_CONTAINER_REF).text()) {
              $(element).find(COUNT_CONTAINER_REF).text(time);
            }
          }
          for (var i = 0; i < entries.length; i++) {
            var url = entries[i];
            var element = document.getElementById(url);
            var countSpan = $(element).find(COUNT_CONTAINER_REF);
            if (countSpan.text() == '') {
              countSpan.text(0);
            }
          }
        })
        .then(function (object, error) {
          console.log("Error: " + error.code + " " + error.message);
        });
    }

    function addCount (Counter) {
      var $visitors = $(".leancloud_visitors");
      var url = $visitors.attr('id').trim();
      var title = $visitors.attr('data-flag-title').trim();
      var query = new AV.Query(Counter);

      query.equalTo("url", url);
      query.find()
        .then(function (results) {
          if (results.length > 0) {
            var counter = results[0];
            counter.save(null, {
              fetchWhenSave: true
            });
            counter.increment("time");
            counter.save()
              .then(function (counter) {
                var $element = $(document.getElementById(url));
                $element.find('.leancloud-visitors-count').text(counter.get('time'));
              })
              .then(function (counter, error) {
                console.log('Failed to save Visitor num, with error message: ' + error.message);
              });
          } else {
            var newcounter = new Counter();
            /* Set ACL */
            var acl = new AV.ACL();
            acl.setPublicReadAccess(true);
            acl.setPublicWriteAccess(true);
            newcounter.setACL(acl);
            /* End Set ACL */
            newcounter.set("title", title);
            newcounter.set("url", url);
            newcounter.set("time", 1);
            newcounter.save()
              .then(function (newcounter) {
                var $element = $(document.getElementById(url));
                $element.find('.leancloud-visitors-count').text(newcounter.get('time'));
              })
              .then(function (newcounter, error) {
                console.log('Failed to create');
              });
          }
        })
        .then(function (error) {
          console.log('Error:' + error.code + " " + error.message);
        })
    }

    $(function () {
      var DELTA = 2000 // 同一接口刷新间隔，防刷
      var Counter = AV.Object.extend("Counter");
      if ($('.leancloud_visitors').length == 1) {
        // console.log(+ new Date() - window.CONFIG.leancloud.addCountTS , DELTA)
        if (!window.CONFIG.leancloud.addCountTS || + new Date() - window.CONFIG.leancloud.addCountTS > DELTA) {
          addCount(Counter);
        }
        window.CONFIG.leancloud.addCountTS = + new Date()
      } else if ($('.post-title-link').length > 1) {
        if (!window.CONFIG.leancloud.showTimeTS || + new Date() - window.CONFIG.leancloud.showTimeTS > DELTA) {
          showTime(Counter);
        }
        window.CONFIG.leancloud.showTimeTS = + new Date()
      }
    });
  }

}

module.exports = leancloud;
